import { CollectionQuery, DataService, WithDocId } from '../data.service';
import { DataPathsService } from '../data-paths.service';
import { switchMap, map, filter } from 'rxjs/operators';
import { combineLatest, firstValueFrom } from 'rxjs';
import { RouteDataService } from '../route';
import { Injectable } from '@angular/core';
import { SlServicesService } from '../../sl-services/sl-services.service';
import { DataEnvService } from '../data-env.service';
import { GeneralSettings, MessageTemplates } from './settings-types';

@Injectable()
export class SettingsData {
    constructor(
        private dataCtrl: DataService,
        private dataPaths: DataPathsService,
        private services: SlServicesService,
        private dataEnv: DataEnvService
    ) {

    }

    public async getGeneralSettings(): Promise<GeneralSettings> {
        const comId = await firstValueFrom(this.dataEnv.comId$);
        const response = await this.services.callService('getGeneralSettings', comId);
        return response as GeneralSettings;
    }

    public async updateGeneralSettings(GeneralSettings: GeneralSettings) {
        await this.services.callService(`updateGeneralSettings`, GeneralSettings);
    }

    public async getMessageTemplates(): Promise<MessageTemplates> {
        const comId = await firstValueFrom(this.dataEnv.comId$);
        const response = await this.services.callService('getMessageTemplates', comId);
        return response as MessageTemplates;
    }

    public async updateMessageTemplates(messageTemplates: MessageTemplates) {
        await this.services.callService(`updateMessageTemplates`, messageTemplates);
    }
}

